import { NgModule } from '@angular/core';

import { PlataformaComponent } from './plataforma.component';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { PlataformaJornadasDigitaisModule } from './pages/plataforma-jornadas-digitais/plataforma-jornadas-digitais.module';
import { PlataformaAssinaturaEletronicaModule } from './pages/plataforma-assinatura-eletronica/plataforma-assinatura-eletronica.module';
import { PlataformaDashboardsModule } from './pages/plataforma-dashboards/plataforma-dashboards.module';
import { PlataformaChatbotsModule } from './pages/plataforma-chatbots/plataforma-chatbots.module';
import { PlataformaCanaisDeContatoModule } from './pages/plataforma-canais-de-contato/plataforma-canais-de-contato.module';
import { PlataformaFormulariosDinamicosModule } from './pages/plataforma-formularios-dinamicos/plataforma-formularios-dinamicos.module';

import { NavegacaoModule } from './components/navegacao/navegacao.module';

@NgModule({
    declarations: [
        PlataformaComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        TranslateModule,

        PlataformaJornadasDigitaisModule,
        PlataformaAssinaturaEletronicaModule,
        PlataformaDashboardsModule,
        PlataformaChatbotsModule,
        PlataformaCanaisDeContatoModule,
        PlataformaFormulariosDinamicosModule,

        NavegacaoModule
    ],
    exports: [
        PlataformaComponent
    ]
})

export class PlataformaModule { }
